var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-card',{staticClass:"mt-3"},[_c('app-head'),_c('b-row',{staticClass:"mt-2"},[_c('b-col',[_c('b',[_vm._v("Leider ist dieser Link nicht gültig")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }